const sizeMap = {
  xs: '0.75rem',
  sm: '0.875rem',
  md: '1rem',
  lg: '1.125rem',
  xl: '1.25rem',
  xxl: '1.5rem',
  xxxl: '1.75rem',
};

const sizeKey = Object.keys(sizeMap).map((k) => k[0].toUpperCase() + k.slice(1));
const sizeAlias = {
  text: 'fontSize',
};

function getSizes({ sizes }: { sizes: string[] }) {
  const sizeStyle = {};
  sizes.forEach((key) => {
    const [alias, color] = key
      .replace(/([A-Z0-9])/g, '-$1')
      .toLowerCase()
      .split('-');
    sizeStyle[sizeAlias[alias]] = sizeMap[color];
  });
  return { sizeStyle };
}

function isSize(key: string) {
  return sizeKey.find((k) => key.endsWith(k));
}

export { getSizes, isSize };
